import { useEffect } from "react";
import { ReactLenis, useLenis } from "lenis/react";
import { useLocation } from "react-router-dom";
import "lenis/dist/lenis.css";

const ScrollTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
};

export const SmoothScroll = ({ children }) => (
  <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
    <ScrollTop />
    {children}
  </ReactLenis>
);
